import { WarningSolid } from '@byway/icons';
import { forwardRef } from 'react';
import {
  FieldError as RAC_FieldError,
  Input as RAC_Input,
  Text as RAC_Text,
  TextField as RAC_TextField
} from 'react-aria-components';
import { Label } from '~/components/Form/Label';
import { Stack } from '~/components/Layout/Stack';
import styles from './TextField.module.css';
import type { TextFieldProps } from './TextField.types';

const TextField = forwardRef<HTMLInputElement, TextFieldProps>(
  ({ errorMessage, hintText, isDisabled, isRequired, label, hasInsideLabel, ...props }, ref) => {
    return (
      <RAC_TextField {...props} data-test-id="TextField" isRequired={isRequired} isDisabled={isDisabled} ref={ref}>
        <Stack space="--by-space-200">
          {!hasInsideLabel && (
            <Label isRequired={isRequired} isDisabled={isDisabled}>
              {label}
            </Label>
          )}
          <RAC_FieldError className={styles.error}>
            <span className={styles.icon}>
              <WarningSolid decorative size="small" />
            </span>
            {errorMessage}
          </RAC_FieldError>
          <div className={styles.inputContainer}>
            <RAC_Input
              className={`${styles.input} ${hasInsideLabel ? styles.inputWithLabel : ''}`}
              placeholder={props.placeholder}
            />
            {hasInsideLabel && label && (
              <span className={styles.insideLabel}>
                {label}
                {isRequired && <span className={styles.requiredStar}> *</span>}
              </span>
            )}
          </div>
          {hintText && (
            <RAC_Text slot="description" className={styles.hintText}>
              {hintText}
            </RAC_Text>
          )}
        </Stack>
      </RAC_TextField>
    );
  }
);

TextField.displayName = 'TextField';

export { TextField };
